import React from "react";

import { appConstants } from "../../config/app-constants";

type Props = {};

const Perquisites172Hint: React.FC<Props> = (props: Props) => {
	return (
		<>
			<section className="text-center">
				<p className="leading-para text-greyDark text-start">
					These are the benefits given to you by your employer, in addition to wages or salary.
					These typically include the following:
				</p>
				<ul className="text-start text-greyDark leading-para">
					<li>Accommodation</li>
					<li>Cars</li>
					<li>ESOPs or Stock Options</li>
					<li>Free meals</li>
					<li>Electricity, Gas or Water</li>
					<li>Club or Holiday expenses</li>
				</ul>

				<h5 className="text-start my-4">17(2) from Form 12BA</h5>

				<img
					src={`${appConstants.basePath}/assets/images/hints/section-17-two-12ba.png`}
					alt="prequisites 17(2) from form 12BA"
					className="img-fluid d-block mx-auto my-4"
				/>
			</section>
		</>
	);
};

export default Perquisites172Hint;
